// extracted by mini-css-extract-plugin
module.exports = {"tumorChannelContent":"tumorChannel_tumorChannelContent__3fnWJ"};